import { toast } from "react-toastify";

import { Icon } from "shared/ui/icon";

export const notifySuccess = (message: string) => {
  return toast.success(message, {
    closeButton: false,
    draggable: true,
    icon: <Icon name="checkInCircle" className="text-dodgerBlue size-5" />,
  });
};
